import { Component, OnInit, Input } from '@angular/core';

import { Customer } from '../transcation';
import { CustomerService } from '../transcation.service';

@Component({
  selector: 'app-transcation-details',
  templateUrl: './transcation-details.component.html',
  styleUrls: ['./transcation-details.component.css']
})
export class TranscationDetailsComponent implements OnInit {

  @Input() customer: Customer;

  constructor(private customerService: CustomerService) { }

  ngOnInit() {
  }

  updateActive(isActive: boolean) {
    this.customerService.updateCustomer(this.customer.key, { active: isActive });
  }

  deleteCustomer() {
    this.customerService.deleteCustomer(this.customer.key);
  }
}
